/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Actions_CreateInputs */

const es_user_profile_api_keys_actions_create = /** @type {(inputs: User_Profile_Api_Keys_Actions_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear clave API`)
};

const en_user_profile_api_keys_actions_create = /** @type {(inputs: User_Profile_Api_Keys_Actions_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create API key`)
};

/**
* | output |
* | --- |
* | "Create API key" |
*
* @param {User_Profile_Api_Keys_Actions_CreateInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_actions_create = /** @type {((inputs?: User_Profile_Api_Keys_Actions_CreateInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Actions_CreateInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_actions_create(inputs)
	return en_user_profile_api_keys_actions_create(inputs)
});
export { user_profile_api_keys_actions_create as "user.profile.api_keys.actions.create" }